import { useEffect, useState } from "react";
import api from "../lib/api";
import ProfileOnboardingTour from "./ProfileOnboardingTour";

/**
 * Mounts the onboarding tour modal exactly once per logged-in owner,
 * automatically deciding whether it's appropriate to surface.
 *
 * Trigger conditions (all must be true):
 *   - owner has a published profile (`has_profile && is_published`)
 *   - profile is NOT yet complete (`is_complete=false`)
 *   - owner hasn't already dismissed the tour
 *     (`onboarding_tour_dismissed_at` is null)
 *
 * Keeping this logic in a tiny wrapper instead of inside the tour itself
 * means the dashboard can safely mount it without conditional rendering
 * — if the tour shouldn't show, this component renders nothing.
 */
export default function ProfileOnboardingTourLauncher() {
  const [data, setData] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get("/owner/profile-completeness")
      .then(({ data }) => mounted && setData(data))
      .catch(() => {});
    return () => { mounted = false; };
  }, []);

  if (!data || dismissed) return null;
  const shouldOpen =
    data.has_profile === true
    && data.is_published === true
    && data.is_complete === false
    && !data.onboarding_tour_dismissed_at;
  if (!shouldOpen) return null;

  return <ProfileOnboardingTour data={data} onDismiss={() => setDismissed(true)} />;
}
